/**
 * Import Dependency
 */
import axios from 'axios'
import store from '../store'
import router from '../router'

/**
 * Config
 */
axios.defaults.timeout = 1000 * 60

/**
 * Declare Variable
 */

/**
 * Config
 */
axios.interceptors.request.use(function(config) {

	let credential = store.getters['auth/getAccessToken'] || '';
	let isAuthorized = store.getters['auth/getIsAuthorized'] || false;

	if (credential!=='' && isAuthorized) {
		config.headers['Authorization'] = 'Bearer ' + credential
	}
	return config
}, error => {
	console.group('[Axios][Interceptor] Request Error')
	console.log(error)
	console.groupEnd()
	return Promise.reject(error)
})

axios.interceptors.response.use(data => {
	return data;
}, (error) => {
	if (error.response.status === 401) {

		let refreshToken = store.state.auth.refreshToken;
		if (refreshToken) {
			//Try to obtain another JWT token if we have a refresh token
			return store.dispatch('auth/refreshToken', {
				refreshToken
			})
				.then((response) => {

					// New request with new token
					let newAccessToken = store.state.auth.accessToken;

					const config = error.config;
					config.headers['Authorization'] = `Bearer ${newAccessToken}`;

					return new Promise((resolve, reject) => {
						axios.request(config).then(response => {
							resolve(response);
						}).catch((error) => {
							reject(error);
						})
					});

				})
				.catch( error => {
					store.dispatch('auth/logout');
					if (router.currentRoute.name !== 'auth.login') {
						router.push({
							name: 'auth.login',
							query: {redirect: router.currentRoute.fullPath}
						});
					}
				});
		}
		else {
			store.dispatch('auth/logout');
			if (router.currentRoute.name !== 'auth.login') {
				router.push({
					name: 'auth.login',
					query: {redirect: router.currentRoute.fullPath}
				});
			}
		}
	}
	else if (error.response.status === 403) {
		store.dispatch('auth/logout');
		if (router.currentRoute.name !== 'auth.login') {
			router.push({
				name: 'auth.login',
				query: {redirect: router.currentRoute.fullPath}
			});
		}
	}
	else {

		let errorMessage = error.message;
		if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) {
			errorMessage = error.response.data.status.message
		}
		if (error.response && error.response.data && error.response.data.message) {
			errorMessage = error.response.data.message
		}

		store.dispatch('pnotify/warning', {
			text: 'There was an error with your request: ' + errorMessage,
			addclass: 'bg-warning border-warning'
		}, {root: true});
	}
    //return;
	//console.group('[Axios][Interceptor] Response Error')
	//console.log(error)
	//console.groupEnd()
	return Promise.reject(error)
})

export default axios